<template>
  <div style="padding: 9.375rem 2.5vw 1.5rem; overflow-x: hidden">
    <div class="homework-box">
      <div class="search-box">
        <el-row type="flex" align="bottom" :gutter="20" style="flex-wrap: wrap">
<!--          <el-col :sm="4" :xs="12">
            <div class="input-title">開始日期</div>
            <el-date-picker
              align="center"
              v-model="form.startDate"
              type="date"
              placeholder="DD/MM/YY"
              format="dd/MM/yyyy"
              clearable
              style="width: 100%"
            >
            </el-date-picker>
          </el-col>
          <el-col :sm="4" :xs="12">
            <div class="input-title">結束日期</div>
            <el-date-picker
              align="center"
              v-model="form.endDate"
              type="date"
              placeholder="DD/MM/YY"
              format="dd/MM/yyyy"
              clearable
              style="width: 100%"
            >
            </el-date-picker>
          </el-col>
          <el-col :xs="9" :sm="9" :lg="10" style="padding-top: 0.625rem">
            <div class="input-title">搜尋</div>
            <el-input
              class="search"
              placeholder="搜尋考試關鍵字"
              v-model="form.keywords"
              prefix-icon="el-icon-search"
            ></el-input>
          </el-col>-->
          <el-col :xs="3" :sm="3" :md="5">
            <el-select @change="search" v-model="form.lang" clearable placeholder="全部版本 All" style="width: 100%">
              <el-option v-for="(item, index) in langList" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </el-col>
          <el-col :xs="3" :sm="3" :md="5">
            <el-select @change="search" v-model="form.objectType" clearable placeholder="全部模式 All" style="width: 100%">
              <el-option label="圖書館/冒險 Library / Adventure" value="0">圖書館/冒險 Library / Adventure</el-option>
              <el-option label="小測 Quiz" value="1">小測 Quiz</el-option>
              <el-option label="評估 Assess" value="2">評估 Assess</el-option>
              <el-option label="作業 Homework" value="3">作業 Homework</el-option>
            </el-select>
          </el-col>
          <el-col
            :lg="{ span: 5, offset: 1 }"
            :xs="7"
            :sm="7"
            style="display: flex; padding-top: 0.625rem"
          >
            <button
              @click="search"
              class="table-button"
              style="background-color: #fcc03a; margin-right: 1rem; flex: 3"
            >
              {{ $t("studentProgramme.search") }}
            </button>
          </el-col>
        </el-row>
      </div>
      <div class="summary-box">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column :label="$t('studentProgramme.mode')" min-width="80">
            <template slot-scope="{ row }">
              <span v-if="row.objectType==0">圖書館/冒險 Library / Adventure</span>
              <span v-if="row.objectType==1">小測 Quiz</span>
              <span v-if="row.objectType==2">評估 Assess</span>
              <span v-if="row.objectType==3">作業 Homework</span>
            </template>
          </el-table-column>
<!--          <el-table-column label="年級" min-width="80">-->
<!--            <template slot-scope="{ row }">-->
<!--              <span v-if="row.gradeId==1">小一</span>-->
<!--              <span v-if="row.gradeId==2">小二</span>-->
<!--              <span v-if="row.gradeId==3">小三</span>-->
<!--              <span v-if="row.gradeId==4">小四</span>-->
<!--              <span v-if="row.gradeId==5">小五</span>-->
<!--              <span v-if="row.gradeId==6">小六</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column prop="topicName" :label="$t('studentProgramme.topicTitle')" min-width="100">
          </el-table-column>
          <el-table-column prop="objectName" :label="$t('studentProgramme.practiseName')" min-width="100">
          </el-table-column>
          <el-table-column
            prop="startTime"
            :label="$t('studentProgramme.startDate')"
            width="140"
            :formatter="myFormatter"
          >
          </el-table-column>
          <el-table-column :label="$t('studentProgramme.duration')" min-width="80">
            <template slot-scope="scope">
              {{scope.row.answeringMinutes}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('studentProgramme.scoreAndTotalScore')" min-width="60">
            <template slot-scope="scope">
              {{scope.row.correctQuantity+'/'+scope.row.score}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('studentProgramme.courseVersion')" min-width="80">
            <template slot-scope="scope">
              {{scope.row.lang==0?'MathConcept香港數學課程':'MathConcept Hong Kong Mathematics Curriculum'}}
            </template>
          </el-table-column>
          <el-table-column width="200" align="center">
            <template slot-scope="scope">
              <button
                class="table-button"
                @click="
                  $router.push({
                    path: '/examinationAnswerResult',
                    query: { type: 'library', topicId: scope.row.topicId, id: scope.row.objectId, gradeId: gradeId, answerResultId: scope.row.id,questionListIds: scope.row.questionListIds,answerValues: scope.row.answerValues},
                  })
                "
              >
                {{ $t("studentProgramme.review") }}
              </button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          v-show="total > 0"
          :small="$store.getters.isPC ? false : true"
          :total="total"
          :autoScroll="false"
          :page.sync="listQ._page"
          :limit.sync="listQ._limit"
          @pagination="getData"
          layout="pager"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getAnswerResults } from "@/api/answerResult";
import Pagination from "@/components/Pagination";
import { formatDateTime, formatDate2 } from "@/filters";
import { isPC } from "@/utils/is-rules.js";
export default {
  props: {
    detail: {
      type: Object,
      default: function () {},
    },
  },
  components: { Pagination },
  name: "home",
  data() {
    return {
      langList: ["MathConcept香港數學課程","MathConcept Hong Kong Mathematics Curriculum"],
      isPC: isPC(),
      total: 0,
      gradeId: null,
      form: {
        studentId: null,
        lang: 0,
        objectType: null,
        gradeId: null,
        startDate: null,
        endDate: null,
        keywords: null,
      },
      listQ: {
        _page: 1,
        _limit: 5,
      },
      tableData: [],
    };
  },
  watch: {
    "$store.getters.currentGradeId": {
      handler(v) {
        this.gradeId = v;
        this.getData();
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getData();
    this.gradeId = this.$store.getters.currentGradeId;
  },
  methods: {
    getData() {
      let form = {
        studentId: this.form.studentId,
        objectType: this.form.objectType,
        gradeId: this.form.gradeId || this.gradeId,
        lang: this.form.lang,
        startDate: formatDate2(this.form.startDate),
        endDate: formatDate2(this.form.endDate),
        keywords: this.form.keywords,
        _page: this.listQ._page - 1,
        _limit: this.listQ._limit,
      };
      getAnswerResults(form).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
    startFormatter(row) {
      return formatDateTime(row.startDate) || "---";
    },
    endFormatter(row) {
      return formatDateTime(row.endDate) || "---";
    },
    myFormatter(row, column, cellValue) {
        return cellValue ? formatDateTime(new Date(cellValue), 'dd/MM/yyyy HH:mm') : '';
    },
    search() {
      this.getData();
    },
    clearSearch() {
      this.form.startDate = "";
      this.form.endDate = "";
      this.form.keywords = "";
      let form = {
        studentId: this.form.studentId,
        gradeId: this.form.gradeId || this.gradeId,
        _page: 0,
        _limit: this.listQ._limit,
      };
      getAnswerResults(form).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
    needHomework(row) {
      if (row.completedAt) return false;
      else if (row.startDate && row.endDate)
        return this.$options.filters["isBetween2"](
          new Date(),
          row.startDate,
          row.endDate
        );
      else false;
    },
  },
};
</script>

<style lang="scss" scoped>
.homework-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 6.25vw;
  background: #ffffff;
  border-radius: 2.5rem;
}
.model-box {
  display: flex;
  text-align: center;
  background: white;
  border: 1px #b62d2e solid;
  border-radius: 2rem;
  padding: 0.25rem;
  margin: 1rem;
}
.model-move {
  position: absolute;
  transition: transform 0.4s linear 0s;
  transform: translateX(0%);
  width: 5rem;
  height: 2rem;
  border-radius: 1rem;
  mix-blend-mode: difference;
  background: #00ffff; //#49d2d1;
}
.model-text {
  line-height: 2rem;
  width: 5rem;
  color: #ff0000; //#B62D2E;
  //mix-blend-mode:screen;
  /*background: #49d2d1;
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;*/
}
.input-title {
  color: #8e8e8e;
  font-weight: 500;
  line-height: 1.6rem;
  font-family: "GenSenRoundedJP", "Helvetica", "Arial";
}
.security-button {
  //margin:1.25rem 0;
  border: 0.0625rem solid #fcc03a;
  background-color: #ffffff;
  font-weight: bold;
  font-size: 1rem;
  color: #444444;
  border-radius: 1.625rem;
  line-height: 2.625rem;
  height: 2.75rem;
}
.search-box {
  font-size: 0.875rem;
  width: 100%;
}
.summary-box {
  width: 100%;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.table-button {
  background: #fcc03a;
  box-shadow: 0px 0.5rem 0 #c28c00;
  border: none;
  border-radius: 2.75rem;
  font-size: 1.5rem;
  line-height: 2rem;
  display: block;
  margin: 0 auto 0.5rem;
  padding: 0.5rem 2rem;
}
/*在768 和991 像素之间的屏幕里，小屏幕，主要是PAD*/
@media (min-width: $minWidth) and (max-width: $maxWidth) {
  .homework-box {
    padding: 1.5rem 6.25vw;
  }
  .summary-box {
    margin-top: 1.5rem;
  }
  .table-button {
    background: #fcc03a;
    box-shadow: 0px 0.5rem 0 #c28c00;
    border: none;
    border-radius: 2.75rem;
    font-size: 1.25rem;
    line-height: 1.5rem;
    display: block;
    margin: 0 auto 0.5rem;
    padding: 0.375rem 1.5rem;
  }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .homework-box {
    padding: 1.5rem 6.25vw;
  }
  .summary-box {
    margin-top: 1.5rem;
  }
  .table-button {
    background: #fcc03a;
    box-shadow: 0px 0.5rem 0 #c28c00;
    border: none;
    border-radius: 2.75rem;
    font-size: 1.25rem;
    line-height: 1.5rem;
    display: block;
    margin: 0 auto 0.5rem;
    padding: 0.375rem 1.5rem;
  }
}
::v-deep {
  .el-select .el-input .el-select__caret {
    color: #b62d2e;
  }
  .el-input__prefix {
    color: #b62d2e;
  }
  .el-date-editor {
    .el-input__prefix {
      left: auto;
      right: 5px;
    }
    .el-input__suffix {
      color: #444444;
      right: 25px;
    }
  }
  .el-input__inner {
    //border-top-right-radius: 3.125rem;
    //border-bottom-right-radius: 3.125rem;
    border-radius: 0.625rem;
    //background-color: #fffbed;
    border: 0.0625rem solid #8e8e8e;
    padding-left: 0.5rem;
    height: 2.75rem;
    line-height: 2.75rem;
  }
  .search .el-input__inner {
    padding-left: 30px;
  }
  .el-icon-search {
    background: url("~@/assets/images/search2.png") center center/contain
      no-repeat;
  }
  .el-icon-search:before {
    content: "";
  }
  .el-table {
    font-size: 1rem;
    /*th + th, td + td{
        margin-right:2rem;
      }*/
  }
  .el-table .cell {
    padding: 0;
    line-height: 3.5rem;
  }
  .el-table th.el-table__cell > .cell {
    padding: 0;
  }
  .el-table th {
    background: #fceedd;
    color: #444444;
  }
  .el-table th:first-child {
    padding-left: 3rem;
  }
  .el-table td:first-child {
    padding-left: 3rem;
  }
}
</style>